import { Injectable } from '@angular/core';
import { HttpClient ,HttpHeaders} from '@angular/common/http';
import { map } from 'rxjs/operators';
@Injectable()
export class ConfigService {
    private Server:string = "";
    private FabricApiUrl:string = "";
    private AppKey:string = "";
    private Console:boolean = false;
    private langs = [];
    private langDefault:number = 1;
    private locale:string = "en-US";
    private Timer:boolean = false;
    private PageSize:number ;
    private LogoutUrl:string = "";
    private isLogoutExternal:boolean = false;
    private sessionStorageEnabled:boolean = false;
    private defaultCurr:string = "AED";
    private client:string = ""
    private customPageTitle:string = "";
    private entitiesPosition:any = {};
    private footer:string='';
    private enableCopyFromButton:string = 'false';
    private timerSeconds:number = 600;
    private isCaptchaAutoTest:boolean = false;
    private reCaptchaSiteKey:string = "6LcnqvErAAAAAMnwSAB6jnOWfV8Ue0jo1gMA8xHa";
    private reCaptchaUrl:string = "https://www.recaptcha.net/recaptcha/api.js";
    // https://www.google.com/recaptcha/api.js
    private otp: boolean = false;
    private uploadMaxFileSize: number = 10; // default 10MB
    private regenerateOtp: boolean = false;
    private timerOtpSeconds:number = 180;
    

    constructor(private _http:HttpClient) { }

    private getNoCacheHttpOptions() {
        return {
            headers: new HttpHeaders({
                'Cache-Control': 'no-cache',
                'Pragma': 'no-cache',
                'Content-Type': 'application/json'
            }),
            params: {
                "cache_bust_date": new Date().getTime()
            }
        }
    }


    public load() {
        return new Promise((resolve, reject) => {
            this._http.get('config.json', this.getNoCacheHttpOptions())  // path of your config.json file
            .subscribe(
                (data:any) => { 
                this.Server = data.server;
                this.FabricApiUrl = data.fabricApiUrl;
                this.AppKey = data.appkey;
                this.Console = data.console;
                this.langs =  data.langs;
                this.langDefault =  data.langDefault;
                this.locale = data.locale;
                this.Timer = data.timer;
                this.PageSize = data.pageSize;
                this.LogoutUrl = data.logoutUrl;
                this.isLogoutExternal = data.isLogoutExternal;
                this.sessionStorageEnabled = data.sessionStorageEnabled;
                this.defaultCurr = data.defaultCurr;
                this.client = data.client;
                this.customPageTitle = data.customPageTitle;
                this.entitiesPosition = data.entitiesPosition;
                this.footer=data.footer;
                this.enableCopyFromButton=data.enableCopyFromButton;
                this.timerSeconds=data.timerSeconds;
                this.isCaptchaAutoTest = data.isCaptchaAutoTest ?? false;
                this.reCaptchaSiteKey = this.isCaptchaAutoTest ? "6LdMI_QrAAAAALzKhQ_QAiGblAVXG7fIpdgoUX5M" : (data.reCaptchaSiteKey ?? this.reCaptchaSiteKey);
                this.reCaptchaUrl = data.reCaptchaUrl ?? this.reCaptchaUrl;
                this.otp = data.otp ?? false;
                this.uploadMaxFileSize = data.uploadMaxFileSize;
                this.regenerateOtp = data.regenerateOtp ?? false;
                this.timerOtpSeconds=data.timerOtpSeconds;
                resolve(true);
                },
                err=>console.log(err)
            );
        });
    }

    public getServer(){
        return  this.Server;
    }

    public getFabricApiUrl(){
        return  this.FabricApiUrl;
    }

    public getAppKey(){
        return  this.AppKey;
    }

    public getConsole(){
        return  this.Console;
    }

    public getLangDefault(){
        return this.langDefault;
    }

    public getLocale(){
        return this.locale;
    }
    public getClient(){
        return this.client;
    }
    public getLangs(){
        return this.langs;
    }

    public getCurrentLocaleStr():string {
        let lang = 'en';
        let langId = localStorage.getItem('langId');

        this.getLangs().forEach(element => {
            if(element['id'] == langId){
                lang = element['text'];
            }
        });

        return lang;
    }

    public getTimer(){
        return  this.Timer;
    }

    public getPageSize(){
        return this.PageSize;
    }

    public getLogoutUrl(){
        return this.LogoutUrl;
    }

    public getIsLogoutExternal(){
        return this.isLogoutExternal;
    }

    public getIsSessionStorage(){
        return this.sessionStorageEnabled;
    }

    public getDefaultCurr(){
        return this.defaultCurr;
    }
    public getCustomPageTitle(){
        return this.customPageTitle;
    }

    public getEntitiesPosition() {
        return this.entitiesPosition;
    }

    public getFooter() {
        return this.footer;
    }

    public getEnableCopyFromButton() {
        return this.enableCopyFromButton;
    }

    public getTimerSeconds() {
        return this.timerSeconds;
    }

    public getIsCaptchaAutoTest() {
        return this.isCaptchaAutoTest ?? false;
    }

    public getReCaptchaSiteKey() {
        return this.reCaptchaSiteKey;
    }

    public getReCaptchaUrl() {
        return this.reCaptchaUrl;
    }
    
    public getOtp(){
        return this.otp;
    }

    public getUploadMaxFileSize(){
        return this.uploadMaxFileSize;
    }

    public getRegenerateOtp(){
        return this.regenerateOtp;
    }

    public getTimerOtpSeconds(){
        return this.timerOtpSeconds;
    }
}